import { Context } from 'Context/Context'
import React, { useContext, useEffect, useState } from 'react'
import { FIRM, firmOverviewApi, isUserVerifiedApi } from 'Constants';
import UnverifiedSavedCases from './UnverifiedSavedCases';
import UserNotVerifiedModal from 'Modals/UserNotVerifiedModal';
import BlurredSampleCases from './SampleCasesBlur';
import { CardSkeleton, CaseListLayout } from './CaseListUI';
import { CASE_TYPES } from './CaseStage';
import OpenCases from './OpenCases';
import MyActiveCases from './MyActiveCases';
import OtherCasesClosed from './OtherCasesClosed';
import ProfessionalStatistics from 'Components/Profile/ProfessionalStatistics';
import ProfNotifications from '../Notifications/ProfNotifications';
import ProfNotificationInsideContent from '../Notifications/ProfNotificationInsideContent';
import SearchContentNotifications from 'Components/Header/SearchContentNotifications';
import AttorneyDashboard from 'Components/Profile/AttorneyDashboard';

function CasesPanelRedirect({attorney, showModal, setShowModal, setAssociateCount, updateComp, setUpdateComp}) {
    const {userDetails, filters} = useContext(Context);
    const userInfo = attorney ? attorney?.userId :  userDetails;
    const noOfFiltersApplied = Object.values(filters).reduce((acc, ele) => acc + ele.length, 0);

    const {selectedMenuItem, makeApiCallFunc} = useContext(Context);

    // Unverified law firm: the firm overview (stats + saved and AI-recommended
    // cases, short summary only) + their verification status. Once they have
    // a firm on their profile, the overview replaces the popup on the case feed
    // - also with no saved cases yet (stats + recommended cases still show).
    // No firm picked yet: the usual case lists, blurred sample cases and the
    // "wait for verification" popup.
    const unverifiedFirm = !attorney && userDetails?.role === FIRM && !userInfo?.verified;
    const [saved, setSaved] = useState({});
    useEffect(() => {
        if (!unverifiedFirm) return;
        const none = { noFirm: true };
        makeApiCallFunc(firmOverviewApi, {}, ({data}) => setSaved((s) => ({ ...s, preview: data || none })), () => setSaved((s) => ({ ...s, preview: none })), null, true);
        makeApiCallFunc(isUserVerifiedApi, { verified: userInfo?.verified }, ({data}) => setSaved((s) => ({ ...s, verified: data?.verified ?? null })), () => setSaved((s) => ({ ...s, verified: null })), null, true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [unverifiedFirm]);
    const onCaseFeed = parseInt(selectedMenuItem) === 1;
    const savedLoading = unverifiedFirm && onCaseFeed && (!('preview' in saved) || !('verified' in saved));
    // no firm picked yet, or the overview couldn't load: the usual popup
    const showSavedList = unverifiedFirm && onCaseFeed && !savedLoading && !!saved.preview && !saved.preview.noFirm;
       useEffect(() => {
       const verified = userInfo?.verified;
        if(verified)
        {
            setShowModal(false);
        }
        else
        {
            setShowModal(true)
        } 
            
    },[selectedMenuItem])
   
    const builder = (selectedMenuItem) => {
        
            console.log("selectedMenuItem", selectedMenuItem)
            switch (parseInt(selectedMenuItem))
            {
                case 1 :
                    
                return <div className='flex flex-col w-full h-full'> 
                    {/* <div className='text-md pt-10 w-full font-bold p-4 text-gray-600 '>
                        {
                        attorney ?
                        ("Hi " + userInfo?.firstName + " " + userInfo?.lastName + ",  please review and request cases available to the attorney, " + attorney?.userId?.firstName + " " + attorney?.userId?.lastName) :     
                        "Hi " + userInfo?.firstName + " " + userInfo?.lastName + ",  please review and request cases available to you" }</div>
                     */}
                        <OpenCases attorney={attorney}
                        updateComp={updateComp}
                        setUpdateComp={setUpdateComp}
                       
                        />
                        </div>
                case 2 :
                    
                return <div className='flex flex-col w-full'> 
                {/* <div className='text-md pt-10 bg-white w-full font-bold p-4 text-gray-600 '>
                    
                {
                        attorney ?
                        ("Hi " + userInfo?.firstName + " " + userInfo?.lastName + ", following are the cases approved for the attorney, " + attorney?.userId?.firstName + " " + attorney?.userId?.lastName + " to view") :     
                        "Hi " + userInfo?.firstName + " " + userInfo?.lastName + ", following are the cases approved for you to view..." }</div>
                         <div className='w-full flex bg-white'>
                        <div className='bg-sky-50 border-sky-600 border-2 text-sky-600 text-sm mb-4 w-max ml-2 p-1 rounded-full font-normal px-2  mb-1 '>
                            
                            {noOfFiltersApplied} filters applied </div>
                            </div> */}
                <MyActiveCases attorney={attorney} updateComp={updateComp}
                        setUpdateComp={setUpdateComp}/>
                </div>
                case 3 :
                return  <div className='flex flex-col w-full'> 
                {/* <div className='text-md pt-10 bg-white w-full font-bold p-4 text-gray-600 '>
                {
                        attorney ?
                        ("Hi " + userInfo?.firstName + " " + userInfo?.lastName + ", following are the cases closed by the attorney, " + attorney?.userId?.firstName + " " + attorney?.userId?.lastName ) :     
                        "Hi " + userInfo?.firstName + " " + userInfo?.lastName + ", following are the cases closed by you..." }</div>
                  <div className='w-full flex bg-white'>
                        <div className='bg-sky-50 border-sky-600 border-2 text-sky-600 text-sm mb-4 w-max ml-2 p-1 rounded-full font-normal px-2  mb-1 '>
                            
                            {noOfFiltersApplied} filters applied </div>
                            </div> */}

                <OtherCasesClosed attorney={attorney}  updateComp={updateComp}
                        setUpdateComp={setUpdateComp}/>
                </div>
                // case 4 : 
                
                // return <div className='flex flex-col w-full'> 
                // {/* <div className='text-md pt-10 bg-white w-full font-bold p-4 border text-gray-600 '>{"Hi " + userInfo?.firstName + " " + userInfo?.lastName + ",  Below are case statistics for you to review" }</div> */}
              
                // <ProfessionalStatistics/>
                // </div>
                case 5 :
                  return  <div className='flex flex-col w-full col-span-6'> 
                                 
                            <SearchContentNotifications attorney={attorney} size="l" userId={attorney?.userId?._id}/>
                            <ProfNotificationInsideContent attorney={attorney} loadInsideContent={true}/>
                  </div>
                case 6 : 
                    return  <div className='flex  flex-col w-full col-span-6'>
                        <AttorneyDashboard attorney={attorney} />
                    </div>
                default:
                <></>
            }
    }
    return (
        <>
       {
        showModal && !userInfo.verified && savedLoading ?
          <CheckingSavedCases/>
        : showModal && !userInfo.verified && showSavedList ?
          <UnverifiedSavedCases overview={saved.preview} verified={saved.verified}/>
        : showModal && !userInfo.verified ?
        <>
          {onCaseFeed && userDetails?.role === FIRM ? <LockedCaseFeed/> : <LockedCasesBackdrop/>}
          <UserNotVerifiedModal uploadNew={showModal} onClose={() => setShowModal(false)}/>
        </>
       :
       
       <>
        <div className='flex w-full  flex-col  '>
            
            {builder(selectedMenuItem)}
        </div>
        
        </>
        
    }
    </>
    );
}

// While we check whether an unverified firm has saved cases: plain loading
// cards (no blurred sample cases), which then become the saved-cases list or
// the locked view with the popup.
function CheckingSavedCases() {
  return (
    <div aria-busy='true' className='w-full bg-cream px-4 py-6 lg:px-10 lg:py-8 min-h-[80vh]'>
      <div className='max-w-[1100px] mx-auto'><CardSkeleton count={2} /></div>
    </div>
  );
}

// Unverified law firm with no saved cases, behind the popup: the usual case
// list menu (SOS / Cases just posted / Available / Requested) with blurred
// made-up sample cases - no real case data.
function LockedCaseFeed() {
  const [active, setActive] = useState(1);
  return (
    <CaseListLayout sectionKey="1" railItems={CASE_TYPES['1']} activeKey={active} onSelect={setActive}>
      <div aria-hidden className='overflow-hidden'><BlurredSampleCases /></div>
    </CaseListLayout>
  );
}

// Shown behind the "not verified yet" popup: made-up sample cases, blurred,
// so the page looks like the case list waiting to unlock (no real case data).
function LockedCasesBackdrop() {
  return (
    <div aria-hidden className='w-full bg-cream px-4 py-6 lg:px-10 lg:py-8 min-h-[80vh] overflow-hidden'>
      <BlurredSampleCases className='max-w-[1100px] mx-auto' />
    </div>
  );
}

export default CasesPanelRedirect